// extracted by mini-css-extract-plugin
export default {"root":"styles_root__7iuB6","checked":"styles_checked__u9mUM"};